var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"csvDsWrapper"}},[_c('csv-datasource',{attrs:{"dealer-id":_vm.dealer.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }